import React from 'react'
import Button from 'react-bootstrap/Button'
import Spinner from 'react-bootstrap/Spinner'
import {connect} from "react-redux";

class PollfishSurvey extends React.Component { 
	
	constructor(props) { 
		super(props)
	}

	componentDidMount() {
		window.onSurveyClosed = this.surveyClosed(this)
	}

	surveyClosedAndCompleted() { 
		console.log("Survey closed and completed")
		alert("WHAT IT DO BABBBBYYEEEEE")
	}

	userNotEligible() { 
		this.setState({surveyData: null, loaded: true})
	}

	surveyNotAvailable() { 
		this.setState({surveyData: null, loaded: true})
	}

	surveyOkay(data) { 
		console.log("Survey available")
		console.log(data)
		this.setState({surveyData: data, loaded: true})
	}

	async surveyClosed() { 
		console.log("Survey closed")
		if (this.props.surveyCompletionSent == true) { 
			this.props.onFinish(null)
		}

		if (this.props.pollfish.completed == true) {
			var requiredMonetization = this.props.survey

			var completion = { 
				income: this.props.pollfish.survey.revenue, 
				category: this.props.pollfish.survey.survey_class,
				monetization_id: requiredMonetization.id
			}
			this.props.onFinish(completion)
		}
	}

	surveyCompleted(data) {
		this.setState({surveyCompleted: true})
	}

	getButtonDisabled() { 
		if (this.props.pollfish.loaded == false) { 
			return true
		} else { 
			return false
		}
	}

	getDescription() { 
		if (this.props.survey.kind === "required_survey") { 
			return <p>Your ticket will be confirmed once you finish the survey</p>
		} else { 
			return null
		}
	}

	getSurveyPlaceholder() {
		if (this.props.pollfish.loaded && this.props.pollfish.completed) {
				return <div>
					<h2>Thanks for the support</h2>
					<p>Thank you for taking the time to help support the event host!</p>
				</div>
		} 
				

		if (this.props.pollfish.loaded && this.props.pollfish.survey === null) { 
			return 	<div style={{textAlign: 'center'}}>
					<h2>Hmm</h2>
					<p>Looks like we couldn't find you a survey. Thanks for waiting.</p>
				</div>
		}

		return <div>
					<h2>Support the Host</h2>
					<p>Free events take a lot of time, energy and investment from event creators.
					You can help support the host by taking a quick short survey.</p> 
					{this.getDescription()}
					</div>
	}

	getButton() { 
		if (this.props.pollfish.completed && !this.props.forceLoading) { 
			if (this.props.survey.kind === "required_survey") { 
					return <Button variant="primary" style={{marginTop: 20}} 
						disabled={this.getButtonDisabled()}
						onClick={()=>this.surveyClosed()} block>
					{this.getButtonStatus()}
		        	</Button>
			}
			return null
		} else { 
			return <Button variant="primary" style={{marginTop: 20}} 
						disabled={this.getButtonDisabled()}
						onClick={()=>this.props.onClick(this.props.pollfish.survey, this.props.pollfish.completed)} block>
					{this.getButtonStatus()}
		        	</Button>
		}
	}

	getButtonStatus() { 
		if (!this.props.pollfish.loaded || this.props.forceLoading) { 
			return <Spinner
			      as="span"
			      animation="border"
			      size="sm"
			      role="status"
			      aria-hidden="true"
    			/>
		} else { 
			return "Continue"
		}
	}

	render() { 
		return (
				<div style={{textAlign: 'center'}}>
					{this.getSurveyPlaceholder()}

					{this.getButton()}
				</div>

				)
	}
}

export default connect(state=>state)(PollfishSurvey)